import { createFileRoute, notFound } from "@tanstack/react-router";
import { getVendor, vendorSlugs } from "@/lib/vendors";
import { VendorRegistrationPage } from "@/components/VendorRegistrationPage";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, serviceSchema, faqPage, breadcrumbList } from "@/lib/schema";

const AREA = [
  { type: "Country" as const, name: "Iraq" },
  { type: "Place" as const, name: "Kurdistan Region of Iraq" },
];

export const Route = createFileRoute("/ar/services/oil-gas-registration/$operator")({
  beforeLoad: ({ params }) => {
    if (!vendorSlugs.includes(params.operator)) throw notFound();
  },
  head: ({ params }) => {
    const v = getVendor(params.operator);
    if (!v || !vendorSlugs.includes(params.operator)) return {};
    const path = `/ar/services/oil-gas-registration/${v.slug}`;
    const url = absolute(path);
    return {
      meta: [
        { title: v.metaTitle.ar },
        { name: "description", content: v.description.ar },
        { property: "og:title", content: v.metaTitle.ar },
        { property: "og:description", content: v.description.ar },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: v.image ? absolute(v.image.src) : OG_IMAGE },
        { property: "og:locale", content: "ar_IQ" },
        { name: "twitter:image", content: v.image ? absolute(v.image.src) : OG_IMAGE },
      ],
      links: [
        { rel: "canonical", href: url },
        ...hreflangLinks(`/services/oil-gas-registration/${v.slug}`),
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            graph(
              serviceSchema({
                path,
                name: v.title.ar,
                serviceType: `${v.name.en} vendor registration`,
                description: v.description.ar,
                areaServed: v.areaServed ?? AREA,
              }),
              faqPage(
                path,
                v.faq.map((f) => ({ q: f.q.ar, a: f.a.ar })),
              ),
              breadcrumbList([
                { name: "الرئيسية", path: "/ar" },
                { name: "خدماتنا", path: "/ar/services" },
                { name: "تسجيل النفط والغاز", path: "/ar/services/oil-gas-registration" },
                { name: v.name.ar, path },
              ]),
            ),
          ),
        },
      ],
    };
  },
  component: VendorOperatorPageAr,
});

function VendorOperatorPageAr() {
  const { operator } = Route.useParams();
  const v = getVendor(operator);
  if (!v || !vendorSlugs.includes(operator)) throw notFound();
  return <VendorRegistrationPage operator={v} />;
}
